<template>
  <div class="center-warp">
    <div class="inner">
      <div class="publish-btn flex-center-center" @click="goTo('/notice_center/publish_notice')"><i class="iconfont icon-xinzeng"></i>发布通知</div>
      <div class="box-table" v-loading="loading">
        <div class="box-table-tr box-table-head black-14">
          <div>序号</div>
          <div>通知内容</div>
          <div>通知对象</div>
          <div>创建时间</div>
          <div>状态</div>
          <div>操作</div>
        </div>
        <div class="box-table-tr black-14" v-for="(item, index) in list">
          <div>{{ ++index }}</div>
          <div>{{ item.content }}</div>
          <div>{{ item.notice_type == 3 ? '所有导师、所有医生': item.notice_type == 1 ? '指定角色' : '指定用户'}}</div>
          <div>{{ item.created_at }}</div>
          <div>{{ item.status == 1 ? '已发送' : '待发送' }}</div>
          <div v-if="item.status != 1"><span class="box-tr-send" @click="noticeOption('send',item)">发送</span><span @click="noticeOption('del',item)" class="box-tr-del">删除</span></div>
        </div>
      </div>
      <Pagination :total="total" :page.sync="queryParams.page" :last_page="last_page" @pagination="getList" :key="queryParams.page" />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import {GetNoticeList, DeleteNotice, SendNotice} from "@/http/api";

export default {
  name: "index",
  components: { Pagination },
  data() {
    return {
      list: [],
      total: 0,
      last_page: 0,
      loading: false,
      queryParams: {
        page: 1,
        pageSize: 20,
        member_id: undefined,
      },
    };
  },
  mounted() {
    this.$store.commit('breadChange',{name:'通知中心',isBack:false})
    var member = JSON.parse(localStorage.getItem("member"));
    this.queryParams.member_id = member.id;
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      GetNoticeList(this.queryParams).then(res=>{
        this.list = res.data.data;
        this.total = res.data.total;
        this.last_page = res.data.last_page;
        this.loading = false;
      })
    },
    goTo(url) {
      this.$router.push(url);
    },
    noticeOption(type,item){
      if(type == 'del'){
        this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          DeleteNotice({id:item.id}).then(res=>{
            if(res.code == 200) this.toastSubmit('success','删除成功')
            else this.toastSubmit('error',res.message[0])
            this.getList()
          })
        })
      }else{
        SendNotice({id:item.id}).then(res=>{
          if(res.code == 200) this.toastSubmit('success','发送成功')
          else this.toastSubmit('error',res.message[0])
          this.getList()
        })
      }
    },
    toastSubmit(type,info){
      this.$message({
        type:type,
        message:info
      })
    }
  },
};
</script>


<style scoped src="../../assets/css/notice_center.css">
</style>
